const pageData = {
    "/": {
      backgroundImage: "/images/hobart2.webp",
      heading: "Welcome",
      description: "Our cutting-edge tools and services help you build stunning web applications faster than ever before.",
    },
    "/general-info/": {
      heading: "General Information",
      description: "Learn about the event and its general information.",
    },
    "/registration/": {
      heading: "Registration",
      description: "Registration is now open for the AusACPDM 2026 Conference.",
    },
    "/accommodation/": {
      heading: "Accommodation",
      description: "Find comfortable and convenient accommodation options for your stay.",
    },
    "/host-and-committee/": {
      heading: "Host and Committee",
      description: "Learn more about the host and committee for the event.",
    },
    "/scholarships/": {
      heading: "Scholarships",
      description: "Explore scholarship opportunities available for attendees.",
    },
    "/discover-hobart/": {
      heading: "Discover Hobart",
      description: "Learn about the city of Hobart and its attractions.",
    },
    "/call-for-abstracts/": {
      heading: "Call for Abstracts",
      description: "Submit your abstract for the conference.",
    },
    "/conference-venue/": {
      backgroundImage: "/images/Chancellor_Hobart.jpg",
      heading: "Conference Venue",
      description: "Explore the conference venue and its surroundings.",
    },
    "/latest-news/": {
      heading: "Latest News",
      description: "Stay updated with the latest news and updates.",
    },
    "/program/": {
      heading: "Program Overview",
      description: "Get a comprehensive overview of the program and sessions.",
    },
    "/promotional-toolkit/": {
      heading: "Promotional Toolkit",
      description: "Download our promotional toolkit to spread the word about our event.",
    },
    "/sponsorship-info/": {
      heading: "Sponsorship Information",
      description: "Learn about sponsorship opportunities and requirements.",
    },
    "/sponsors-and-exhibitors/": {
      heading: "Sponsors and Exhibitors",
      description: "See our valued sponsors and exhibitors and their contributions to the event.",
    },
    "/privacy-policy/": {
      heading: "Privacy Policy",
      description: "Learn about our privacy policy and data protection practices.",
    },
    "/contact/": {
      heading: "Contact Us",
      description: "Get in touch with us for any inquiries or support.",
    },
  };
  
  export const getPageData = (path) => {
    const defaultData = {
      backgroundImage: "/images/hobart3.webp",
    };
  
    const data = pageData[path] || {};
  
    return {
      ...defaultData,
      ...data,
    };
  };
  